import React from "react";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ProfileListing from "../../ProfileListing";
import "./BusinessListings.scss";

const PREVIEW_LIMIT = 9;

export default function BusinessListings({
  listings = [],
  ownerId,
  onOpenListing,
}) {
  const navigate = useNavigate();

  const safeListings = Array.isArray(listings) ? listings : [];
  const previewListings = safeListings.slice(0, PREVIEW_LIMIT);
  const hasMore = safeListings.length > PREVIEW_LIMIT;

  const openAllListings = () => {
    if (ownerId) {
      navigate(
        `/profile/${encodeURIComponent(ownerId)}/listings`
      );
      return;
    }

    navigate("/business/listings");
  };

  return (
    <div className="businessListings">
      <ProfileListing
        listings={previewListings}
        userId={ownerId}
        onOpenListing={onOpenListing}
      />

      {hasMore && (
        <button
          type="button"
          className="businessListings__showMore"
          onClick={openAllListings}
        >
          <span>
            Показати більше
            <small>
              Ще {safeListings.length - PREVIEW_LIMIT}
            </small>
          </span>

          <ChevronRight
            size={19}
            strokeWidth={2.4}
          />
        </button>
      )}
    </div>
  );
}